 export const lineage  ={
    "name": "snacking_eus2_dev.mw_edm_eu_inventory.projected_balance_baseline",
    "columns": [
        "as_of_dt",
        "expired_quantity",
        "kinaxis_projection_date",
        "lead_time",
        "load_timestamp",
        "main_zrep",
        "on_hand_qi_maturation_quantity",
        "on_hand_quantity",
        "part_description",
        "part_name",
        "primary_source",
        "projected_inventory_quantity",
        "projection_date",
        "projection_type",
        "safety_stock_quantity",
        "site_id",
        "source_system_timestamp",
        "transfer_quantity",
        "transfer_to"
    ],
    "upstreams": [
        {
            "child": "snacking_eus2_dev.mw_supply_raw_eu_kinaxis.projected_balance_marswk_baseline",
            "columns": [
                "DATE",
                "DESCRIPTION",
                "EXPIRED_QUANTITY",
                "INGESTED_TIME",
                "LEAD_TIME",
                "MAIN_ZREP",
                "ON_HAND",
                "ON_HAND_QI_MATURATION",
                "PART",
                "PRIMARY_SOURCE",
                "PROJECTED_INVENTORY",
                "SAFETY_STOCK",
                "SITE",
                "TRANSFER",
                "TRANSFER_TO",
                "as_of_dt",
                "load_timestamp"
            ]
        },
        {
            "child": "snacking_eus2_dev.mw_supply_raw_eu_kinaxis.projected_balance_everyday_baseline",
            "columns": [
                "DATE",
                "DESCRIPTION",
                "EXPIRED_QUANTITY",
                "INGESTED_TIME",
                "LEAD_TIME",
                "MAIN_ZREP",
                "ON_HAND",
                "ON_HAND_QI_MATURATION",
                "PART",
                "PRIMARY_SOURCE",
                "PROJECTED_INVENTORY",
                "SAFETY_STOCK",
                "SITE",
                "TRANSFER",
                "TRANSFER_TO",
                "as_of_dt",
                "load_timestamp"
            ]
        }
    ],
    "downstreams": [
        {
            "parent": "snacking_eus2_dev.mw_edm_eu_inventory.mw_edm_eu_inventory_projected_balance_baseline_anomaly_records",
            "columns": [
                "_errors"
            ]
        },
        {
            "parent": "abfss://process@dnae2esclakeeus2devsa.dfs.core.windows.net/EU/INVENTORY/governance/data_quality/simpel_dqx/anomaly_records/PROJECTED_BALANCE_SILVER_NEW/mw_edm_eu_inventory|projected_balance_baseline",
            "columns": []
        },
        {
            "parent": "snacking_eus2_dev.mw_e2esupplychain_imos_eu_silver.kinaxis_projected_inventory",
            "columns": [
                "materialNumber",
                "materialText",
                "plant",
                "sourceType",
                "zrep"
            ]
        }
    ]
};